import type { CompetencyGroup } from '@/types/competency/Competency';

import { api } from '@/api/api';

export interface ImportCompetenciesPayload {
    competencyIds: string[];
}

export default {
    async getCompetencyCatalog(): Promise<CompetencyGroup[]> {
        const response = await api.get(`/Competency/explore`);

        return response.data;
    },

    async importCompetencies(payload: ImportCompetenciesPayload): Promise<void> {
        await api.post(`/Competency/import`, payload);
    },
};
